<footer class="footer-area">
  <div class="footer-container">
    <!-- Columna 1: Información institucional -->
    <div class="footer-col">
      <h3>OSOETSYLRA - Signo Médico</h3>
      <p class="website-link">
        <a href="https://www.osoetsylra.com.ar" target="_blank" rel="noopener">
          www.osoetsylra.com.ar
        </a> /
        <a href="https://www.instagram.com/uoetsylra_oficial/" target="_blank" rel="noopener" class="instagram-link">
          @uoetsylra_oficial
        </a>
      </p>
      <p class="about-text">
        Bajo la denominación de la OBRA SOCIAL DE OBREROS Y EMPLEADOS TINTOREROS, SOMBREREROS Y LAVADEROS DE LA REPUBLICA ARGENTINA- O.S.O.E.T.S.Y.L.R.A. -, se constituye una Obra Social que funcionará como entidad de derecho público no estatal con individualidad jurídica, administrativa y financiera, con el alcance que el Código Civil establece para las personas jurídicas.
      </p>
      <p class="copyright-text">© Todos los derechos reservados</p>
    </div>

    <!-- Columna 2: Dirección / Teléfonos / Turnos -->
    <div class="footer-col">
      <h3>Dirección</h3>
      <div class="info-block">
        <span class="material-icons">location_on</span>
        <a href="https://maps.app.goo.gl/9nPG44uHVXFvBNF2A" target="_blank" rel="noopener" class="address-link">
          Culpina 31 - CABA - C1406ENA<br>Buenos Aires - República Argentina
        </a>
      </div>

      <h3>Teléfonos</h3>
      <div class="info-block">
        <span class="material-icons">phone</span>
        <span>
          EMERGENCIAS Y URGENCIAS: <strong>0800-333-1147</strong><br>
          ATENCIÓN DEL AFILIADO: <strong>0810-333-4485</strong>
        </span>
      </div>

      <h3>Turnos</h3>
      <div class="info-block">
        <span class="material-icons">smartphone</span>
        <span>
          CULPINA: <strong>11 3921-5242</strong><br>
          SAN MARTÍN: <strong>11 6726-4034</strong>
        </span>
      </div>
    </div>

    <!-- Columna 3: Legal / TecnoDret / Contacto -->
    <div class="footer-col">
      <app-tecnodret></app-tecnodret>
      <p class="sss-text">
        Superintendencia de Servicios de Salud - Órgano de Control de Obras Sociales y Entidades de Medicina Prepaga - 0800-222-SALUD (72583) - RENOS 1-2740-6
      </p>
      <img src="assets/img/salud.png" alt="Superintendencia de Salud" class="sss-logo">
      <p class="rnemp">R.N.E.M.P. No 1-1109-04</p>

      <div class="legal-links">
        <a (click)="openBlank('TC')" class="legal-link">
          <span class="material-icons">lock</span> Términos y condiciones
        </a>
        <a (click)="openBlank('PDP')" class="legal-link">
          <span class="material-icons">lock</span> Protección de datos personales
        </a>
      </div>
    </div>
  </div>

  <!-- Franja inferior -->
  <div class="footer-bottom">
    <p>
      <span class="material-icons">copyright</span> {{ currentYear }} SignoMédico by
      <a href="https://cipbyte.io/" target="_blank" rel="noopener">
        <strong>CipByte</strong>
      </a> {{ appVersion }}
    </p>
  </div>

  <!-- Líneas decorativas -->
  <div class="lines">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</footer>